import { Text } from "./Text";
import { CustomText } from "../../../../types";
import { TextEditable } from "./TextEditable";
import { useTemplatesStatusStore } from "../../../../store/useTemplatesStatusStore";
import { useTemplateEditorStore } from "../../../../store/useTemplateEditorStore";
import { mapRelativeToPixels } from "../../../../helpers/itemsHelper";

export const TemplateCustomTexts = ({
  customTexts,
  previewWidth,
  previewHeight,
  editable = false,
}: {
  customTexts: CustomText[];
  previewWidth: number;
  previewHeight: number;
  editable?: boolean;
}) => {
  const { updateCustomText, currentItem } = useTemplateEditorStore((store) => ({
    updateCustomText: store.updateCustomText,
    currentItem: store.templateState.currentItem,
  }));
  const { addTemplateUpdate } = useTemplatesStatusStore((state) => ({
    addTemplateUpdate: state.addTemplateUpdate,
  }));

  const handleContentChange = (params: Partial<CustomText>) => {
    updateCustomText(params);
    addTemplateUpdate();
  };

  return customTexts.map((text) =>
    editable ? (
      <TextEditable
        key={text.id}
        textItem={text}
        previewWidth={previewWidth}
        previewHeight={previewHeight}
        onChange={(params) =>
          handleContentChange(params as Partial<CustomText>)
        }
      />
    ) : (
      <div
        key={text.id + currentItem?.id}
        style={{
          position: "absolute",
          top: mapRelativeToPixels(text.position.y, previewHeight),
          left: mapRelativeToPixels(text.position.x, previewWidth),
          width: mapRelativeToPixels(text.size.width, previewWidth),
          height: mapRelativeToPixels(text.size.height, previewHeight),
          zIndex: text.layerIndex,
          textAlign: text.textAlign,
          transformOrigin: "center",
          transform: text.rotation ? `rotate(${text.rotation}deg)` : undefined,
        }}
      >
        <Text
          textItem={text}
          previewWidth={previewWidth}
          previewHeight={previewHeight}
        />
      </div>
    )
  );
};
